<template>
  <div>
    <span
      style="
        color: #007bff;
        cursor: pointer;
      "
      @click.stop="$bvModal.show(`preview-edm-${notificationId}`)"
    >
      查看
    </span>
      <b-modal :id="`preview-edm-${notificationId}`" size="lg" hide-footer>
      <template #modal-title>
        EDM 預覽
      </template>
      <iframe
        :src="htmlUrl | imagePath('notificationEdmHtml')"
        width="100%"
        frameborder="0"
        style="overflow: hidden"
        onload="this.style.height=`${this.contentWindow.document.body.scrollHeight}px`"
      ></iframe>
    </b-modal>
  </div>
</template>

<script>
import imagePath from '@/filters/image-path';
import { BModal } from 'bootstrap-vue';

export default {
  filters: {
    imagePath,
  },
  components: {
    BModal,
  },
  props: {
    htmlUrl: {
      type: String,
      required: true,
    },
    notificationId: {
      type: Number,
      required: true,
    },
  },
};
</script>
